import { Skeleton } from '@mui/material'
import clsx from 'clsx'
import { Card } from 'components/core-v2'
import React from 'react'

import classes from './unit-transfers-main.module.scss'

const UnitTransfersAssetsLoading = () => (
  <div>
    <Skeleton height="150px" variant="rectangular" width="380px" />
    <Skeleton height="210px" variant="rectangular" width="380px" />
    <Skeleton height="180px" variant="rectangular" width="380px" />
  </div>
)

export const UnitTransfersLoading = () => (
  <main className={clsx(classes.main)}>
    <Card.Wrapper className={classes.cardWrapper}>
      <div className={clsx(classes.gridWrapper, classes.loading)}>
        <div className={clsx(classes.loadingTrades)}>
          <Skeleton height="210px" variant="rectangular" width="280px" />
          <Skeleton height="180px" variant="rectangular" width="280px" />
        </div>
        <div className={clsx(classes.loadingAssets)}>
          {new Array(3).fill(null).map((_, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <UnitTransfersAssetsLoading key={i} />
          ))}
        </div>
      </div>
    </Card.Wrapper>
  </main>
)
